import React from 'react';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import electricien from '../images/electricien.jpg';
import { motion } from 'framer-motion';
import AnimatedBackgroundBox from "./AnimationBackgroundBox";

const HeroSection = () => {
    return (
        <AnimatedBackgroundBox backgroundImage={electricien} position={'center'} size={'200%'}>
            <Box
                component={motion.div}
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 1, delay: 0.5, ease: 'easeOut' }}
                maxWidth="lg"
                sx={{
                    position: 'absolute',
                    // top: '50%',
                    // left: '50%',
                    // transform: 'translate(-50%, -50%)',
                    backgroundColor: 'transparent',
                    padding: {
                        md: '20px', // Plus de padding pour les grands écrans
                    },
                }}
            >
                <Typography
                    variant="h2"
                    sx={{
                        fontWeight: 'bold',
                        color: '#ffffff',
                        fontSize: {
                            xs: '2.5rem', // Taille plus petite sur les téléphones
                            sm: '2.5rem', // Taille moyenne sur les tablettes
                            md: '4rem', // Taille normale sur les grands écrans
                        },
                        textShadow: `
                            0px 0px 8px rgba(0, 0, 0, 0.3),   
                            0px 0px 16px rgba(0, 0, 0, 0.3),  
                            0px 0px 24px rgba(0, 0, 0, 0.3)
                        `,
                        fontFamily: 'unset',
                    }}
                >
                    Sécurité et confiance, <br />
                    au cœur de notre énergie
                </Typography>
            </Box>
        </AnimatedBackgroundBox>
    );
};

export default HeroSection;
